import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const manualIntegralList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-integral/v1/detail/manualIntegralList?` + params,
        method: 'GET'
    })
}
export const downloadExcelIntegral = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-integral/v1/detail/downloadExcelIntegral?` + params,
        method: 'GET'
    })
}